import React, { useEffect } from "react";
import { Dialog, Button, Image } from "hesus-ui-kit";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { renderPriceWithCurrency } from "@utils/utils";
import Documents from "./components/Documents/Documents";
import {
  HeaderWrapper,
  Title,
  FormBody,
  ButtonWrapper,
  MapContainer,
  LineBreak,
} from "./SolutionView.styled";

import initMap from "@utils/map";
import closeIcon from "@icons/ic-close-white.svg";

import SolutionInfo from "./components/SolutionInfo";
import Comments from "./components/Comments";

const SolutionView = (props) => {
  const { id, solutionData, onClose, onEdit, t, isEditBtnVisible } = props;

  const solutionByIds = useSelector((state) => state.solutionsList.byId);
  let selectedSolution = {};
  if (solutionData !== null) selectedSolution = solutionData;
  else selectedSolution = solutionByIds[id];

  const selectedTransportPrice =
    selectedSolution.solutionTransportPrices &&
    selectedSolution.solutionTransportPrices.length > 0
      ? selectedSolution.solutionTransportPrices?.find(
          (priceItem) => priceItem.selectedPrice === true
        )
      : selectedSolution.solutionTransportPrice;

  const selectedTreatmentPrice =
    selectedSolution.solutionTreatmentPrices &&
    selectedSolution.solutionTreatmentPrices.length > 0
      ? selectedSolution.solutionTreatmentPrices[0]
      : selectedSolution.solutionTreatmentPrice;

  useEffect(() => {
    if (selectedSolution?.site && selectedSolution?.centre) {
      initMap(
        "map",
        selectedSolution.site.position.latitude,
        selectedSolution.site.position.longitude,
        selectedSolution.centre.position.latitude,
        selectedSolution.centre.position.longitude,
        false
      );
    }
  }, [
    selectedSolution?.site,
    selectedSolution?.centre,
    selectedSolution?.site?.position.latitude,
    selectedSolution?.site?.position.longitude,
    selectedSolution?.centre?.position.latitude,
    selectedSolution?.centre?.position.longitude,
  ]);

  return (
    <Dialog>
      <>
        <HeaderWrapper>
          <Title>{`${t("SOLUTION_VIEW_TITTLE")} #${id}`}</Title>
          <Button
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
            onClick={onClose}
          >
            <Image
              src={closeIcon}
              alt="close selling price popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <SolutionInfo
            priceType={selectedSolution.priceType}
            centre={
              selectedSolution.centre?.companyId
                ? {
                    id: selectedSolution.centre.companyId,
                    name: selectedSolution.centre.companyName,
                  }
                : null
            }
            supplier={
              selectedSolution.centre?.supplierId
                ? {
                    id: selectedSolution.centre?.supplierId,
                    name: selectedSolution.centre?.supplierName,
                  }
                : null
            }
            haulier={
              selectedSolution.haulier?.companyId
                ? {
                    id: selectedSolution.haulier?.companyId,
                    name: selectedSolution.haulier?.name,
                  }
                : {
                    id: selectedSolution.site?.id,
                    name: selectedSolution.site?.name,
                  }
            }
            product={selectedSolution.centreProduct?.product?.name ?? ""}
            transportType={selectedTransportPrice?.transportType?.name ?? ""}
            treatmentPrice={
              selectedTreatmentPrice
                ? `${selectedTreatmentPrice.price} ${
                    selectedTreatmentPrice.currency?.name ?? ""
                  }/${t(selectedTreatmentPrice.unit)}`
                : ""
            }
            transportPrice={
              selectedTransportPrice
                ? renderPriceWithCurrency(
                    selectedTransportPrice.price ?? "",
                    t(selectedTransportPrice.unit),
                    selectedTransportPrice.currency.symbol,
                    selectedTransportPrice.currency.position
                  )
                : ""
            }
            treatmentTransportPrice={
              selectedTransportPrice
                ? renderPriceWithCurrency(
                    selectedTransportPrice.price ?? "",
                    t(selectedTransportPrice.unit),
                    selectedTransportPrice.currency.symbol,
                    selectedTransportPrice.currency.position
                  )
                : ""
            }
          />
          <LineBreak />
          {(selectedSolution.internalComment ||
            selectedSolution.quoteComment ||
            selectedSolution.pollutionComment ||
            selectedTransportPrice?.comment) && (
            <>
              <Comments
                priceType={selectedSolution.priceType}
                purchasePriceAssumption={selectedSolution.internalComment}
                specificConditions={selectedSolution.quoteComment}
                transportQuotationDetails={
                  selectedTransportPrice?.comment ?? ""
                }
                concernedPollution={selectedSolution.pollutionComment}
              />
              <LineBreak />
            </>
          )}
          <Documents
            id={id}
            companyId={
              selectedSolution.priceType !== 3
                ? selectedSolution.centre?.supplierId
                : selectedSolution.haulier?.companyId ??
                  selectedSolution.site.companyId
            }
          />
          {selectedSolution?.site && selectedSolution?.centre && (
            <MapContainer id="map" />
          )}
        </FormBody>
        <ButtonWrapper>
          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              marginRight: "5px",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            <>{t("CLOSE")}</>
          </Button>
          {selectedSolution.solutionStatus.id !== 2 &&
            selectedSolution.solutionStatus.id !== 8 &&
            selectedSolution.solutionStatus.id !== 9 &&
            isEditBtnVisible && (
              <Button
                styles={{
                  color: "white",
                  background: "#1BACE4",
                  border: "1px solid #1BACE4",
                  "&:hover": {
                    backgroundColor: "#1589b6",
                  },
                }}
                onClick={onEdit}
              >
                <>{t("EDIT")}</>
              </Button>
            )}
        </ButtonWrapper>
      </>
    </Dialog>
  );
};

SolutionView.propTypes = {
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isEditBtnVisible: PropTypes.bool,
  solutionData: PropTypes.object,
};

SolutionView.defaultProps = {
  isEditBtnVisible: true,
  solutionData: null,
};

export default withTranslation()(SolutionView);
